import { useTran } from 'src/i18n/useTran'
import { useTheme } from 'src/ui/style/useTheme'
import { FooterColumn } from 'src/layout/footer/FooterColumn'
import { View } from 'src/ui/basic/View'
import { verticalChildSpacing } from 'src/ui/style/mixins/layout'
import { Text } from 'src/ui/basic/Text'
import React from 'react'
import { msg } from 'src/i18n/texts/keys'
import { getAppContext } from '../../context/AppContext'
import { getEnvConfVal } from 'src/conf/getEnvConfVal'

// @ts-ignore
import CAF from 'src/brand/assets/caf200.png'
import { Image } from 'src/ui/img/Image'
import { Theme } from 'src/ui/style/Theme'
import { css } from 'src/ui/style/css'

export default {
    CAF
}

export const titleStyle = () => (th: Theme) =>
    css`
        padding-top: 6px;
        margin-bottom: 0.5rem !important;
        text-transform: uppercase;
        font-weight: ${th.fontWeight.bold};
    `

export const iOS = () => {
    return (
        [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    )
}

export const grid = ({
    minWidth,
    maxWidth = '1fr',
    gap,
    auto = 'fit',
    autoRows = false
}: {
    minWidth: string
    maxWidth?: string
    gap?: string
    auto?: 'fit' | 'fill'
    autoRows?: boolean
}) => css`
    display: grid;
    grid-template-columns: repeat(
        ${`auto-${auto}`},
        minmax(${minWidth}, ${maxWidth})
    );
    ${gap && `grid-gap: ${gap};`}
    // Rows have same height according to highest row
    ${autoRows && 'grid-auto-rows: 1fr;'}
`

export const InfoColumn = () => {
    const t = useTran()
    const th = useTheme()
    const address = getAppContext()?.config?.address
    const billing = getAppContext()?.config?.billing
    const formatLocale = getEnvConfVal('FORMAT_LOCALE')
    return (
        <FooterColumn title={t(msg.ui.footer.infoColumn.title)}>
            <View css={verticalChildSpacing(th.spacing.sm)}>
                <Text>{address.name}</Text>
                <Text>{address.street}</Text>
                <Text>{`${address.zipCode} ${address.city}`}</Text>
                <Text>{address.country}</Text>
            </View>
            <View css={verticalChildSpacing(th.spacing.sm)}>
                {billing?.ico && (
                <Text>{`${t(msg.ui.footer.infoColumn.ico)}: ${
                    billing.ico
                }`}</Text>
                )}

                {billing?.dic && (
                    <Text>{`${t(msg.ui.footer.infoColumn.dic)}: ${
                        billing.dic
                    }`}</Text>
                )}

                {billing?.icDph && (
                    <Text>{`${t(msg.ui.footer.infoColumn.icDph)}: ${
                        billing.icDph
                    }`}</Text>
                )}

                {billing?.iban && (
                    <Text>{`${t(msg.ui.footer.infoColumn.iban)}: ${
                        billing.iban
                    }`}</Text>
                )}
            </View>
            {formatLocale === 'cs' && (
                <Text css={titleStyle()}>
                    {t(msg.ui.footer.infoColumn.membershipTitle)}
                </Text>
            )}
            {formatLocale === 'cs' && (
                <View
                    css={[
                        grid({
                            minWidth: '2.5em',
                            gap: '0.25em',
                            auto: 'fill'
                        }),
                        css`
                            align-items: flex-end;
                        `
                    ]}
                >
                    <a
                        rel="noreferrer"
                        href="https://www.czech-franchise.cz/"
                        target="_blank"
                    >
                        <Image alt={'CAF'} src={CAF} width={49} height={49} />
                    </a>
                </View>
            )}
        </FooterColumn>
    )
}
